import React from 'react';
import { RootPageComponent } from '@app/ui/pages/root-page/root-page.component';

export const RootPageContainer = () => {
  return <RootPageComponent />;
};
